import {
  BootstrapUtility,
  FeatureParam,
  FeatureFlag,
  Logger,
  TsConfig
} from './utility/VizclientUtils';

export class FeatureFlagUtils {
  // Pass the EventUtilsEventHandlingRework feature flag to the module here
  public static SetFeatureFlagIsEventHandlingReworkEnabled(shim: () => boolean): void {
    FeatureFlag.IsEventHandlingReworkEnabled = shim;
  }
  // Pass the feature param to the module here
  public static SetFeatureParamDebugTools(shim: () => boolean): void {
    FeatureParam.DebugTools = shim;
  }
  // Pass the tsconfig to the module here
  public static SetTsConfigIsMobile(shim: () => boolean): void {
    TsConfig.IsMobile = shim;
  }
  // Pass the bootstraputil to the module here
  public static SetBootStrapUtilIsEmbedded(shim: () => boolean): void {
    BootstrapUtility.IsEmbedded = shim;
  }

  public static SetLoggerDebug(shim: (_: string) => void): void {
    Logger.Debug = shim;
  }

  public static SetAllShimsToFallback(): void {
    const fallbackShim: () => boolean = () => false;

    FeatureFlagUtils.SetFeatureFlagIsEventHandlingReworkEnabled(fallbackShim);
    FeatureFlagUtils.SetFeatureParamDebugTools(fallbackShim);
    FeatureFlagUtils.SetTsConfigIsMobile(fallbackShim);
    FeatureFlagUtils.SetBootStrapUtilIsEmbedded(fallbackShim);
  }
}

export { NormalizedEvent } from './event/NormalizedEvent';
export { MouseEventUtil } from './utility/MouseEventUtil';
export { EventHandleSpec } from './EventHandleSpec';
export { EventForwarder, EventForwarderProps } from './EventForwarder';
export { TableauEventHandler } from './TableauEventHandler';
export { TableauEventHandlerForReact } from './TableauEventHandlerForReact';
export { Gesture } from './gesture/Gesture';
export { Drag } from './gesture/Drag';
export { GlobalUIEvents } from './GlobalUIEvents';
export { Hover } from './gesture/Hover';
export { MiscUtil } from './utility/MiscUtil';

export { ZoomScaleUtil } from './utility/ZoomScaleUtil';
export { IMouseCaptureEventHandler } from './definition/IMouseCaptureEventHandler';

export { DragDropManager } from './dragdrop/DragDropManager';
export { IAvatar } from './dragdrop/IAvatar';
export { AvatarDelta, AvatarSourceRect, SimpleAvatar } from './dragdrop/SimpleAvatar';
export { IDragSource, DragSourceType } from './dragdrop/IDragSource';
export { IDropTarget } from './dragdrop/IDropTarget';
export { DragInstance } from './dragdrop/DragInstance';
export { DragType } from './dragdrop/DragType';
export { DelegateDropTarget } from './dragdrop/DelegateDropTarget';
export { IDragResponder } from './dragdrop/IDragResponder';
export { DropFeedbackType } from './dragdrop/DropFeedbackType';
export { DropResult } from './dragdrop/DropResult';
export { EmbeddedCustomCursor, ICustomCursor } from './dragdrop/EmbeddedCustomCursor';
